import React from 'react';
import '../../../App.css';
import withStyles from "@material-ui/core/styles/withStyles";
import MaterialTable from 'material-table';
import {
	Badge,
	Button,
	Chip,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	ListItemIcon,
	Menu,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core';
import {
	AddShoppingCart,
	CheckCircleOutline,
	HighlightOff,
	InfoOutlined,
	MoreVert,
	NotificationsNone
} from '@material-ui/icons';
import { get as getResources } from "../network/Resources";
import { create, update, get, delet } from "../network/PO";
import {
	create as createRequest,
	get as getRequests,
	review,
	permissions,
	canReview
} from "../network/PORequests";
import { getAllowedLicenseCount, getUsedLicenseCount } from "../network/Authwalls";
import { routePermissions } from "../../auth/network/Login";
import { withCookies } from "react-cookie";
import { Message, Grid } from 'shineout'

const service = 'pos';
const path = '';

// WAITING is what the DB stores; "Pending" is what an approver reads.
const STATUS = {
	WAITING: { label: 'Pending', color: '#8a6100', background: '#fff4d6', border: '#f0c36d' },
	APPROVED: { label: 'Approved', color: '#0b6b2f', background: '#e3f6e9', border: '#7dc79a' },
	REJECTED: { label: 'Rejected', color: '#8c1c13', background: '#fdeaea', border: '#e79b95' }
};

const fmt = date => (date ? new Date(date).toLocaleDateString('en-GB') : '—');

const styles = theme => ({
	theme: theme,
	root: {
		display: 'wrap',
	},
	field: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1)
	}
});

class POList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			attributes: {},
			vendors: [],
			pos: [],
			requests: [],
			data: [],
			total_count: 0,
			used_count: 0,
			isLoading: true,
			POST: false,
			GET: false,
			PUT: false,
			DELETE: false,
			// po_requests permissions — separate service, separate probe
			canRaise: false,
			canReview: false,
			vendorScope: ['*'],
			attributeScope: ['*'],
			// bell: show only what is still waiting on someone
			pendingOnly: false,
			// row menu
			menuAnchor: null,
			menuRow: null,
			// dialogs
			detailsRow: null,
			requestOpen: false,
			form: { vendor: '', attribute: '', quantity: '', remarks: '' },
			submitting: false,
			reviewOpen: false,
			reviewRow: null,
			reviewStatus: 'APPROVED',
			reviewPo: '',
			reviewReason: ''
		};
	}

	componentDidMount() {
		getResources({ type: "attribute" }, data => {
			var attributes = {};
			data.map(e => (attributes[e.name] = e.name));
			this.setState({ attributes: attributes });
		});
		// Admin raises on behalf of a vendor, so it needs the vendor master list.
		// A single-vendor OEM's vendor comes from its policy scope, not from here.
		getResources({ type: "vendor" }, data => {
			this.setState({ vendors: data.map(e => e.name).sort() });
		});

		routePermissions(this.props, { service: service, path: path }, result => {
			if (result === null) {
				this.setState({ isError: true, isLoading: false });
				return;
			}
			var next = {};
			result.forEach(method => { next[method.name] = true; });
			this.setState(next, () => {
				this.reloadPos();
				this.refreshCounts();
			});
		});

		// po_requests is its own service and may simply not be granted — permissions()
		// returns null instead of logging the user out the way routePermissions() would.
		permissions('', result => {
			if (result === null) {
				this.setState({ canList: false }, this.merge);
				return;
			}
			var post = result.find(method => method.name === 'POST');
			var next = { canRaise: !!post, canList: !!result.find(m => m.name === 'GET') };
			if (post) {
				var scope = key => {
					var resource = (post.resources || []).find(r => r.key === key);
					return resource ? resource.value : ['*'];
				};
				next.vendorScope = scope('vendor');
				next.attributeScope = scope('attribute');
			}
			this.setState(next, this.reloadRequests);
		});
		// Approve/reject lives on its own route, so it needs its own probe.
		canReview(allowed => this.setState({ canReview: allowed }));
	}

	reloadPos = () => {
		if (!this.state.GET) {
			this.setState({ isLoading: false });
			return;
		}
		get({}, data => this.setState({ pos: data, isLoading: false }, this.merge));
	};

	reloadRequests = () => {
		if (this.state.canList === false) {
			this.merge();
			return;
		}
		getRequests({}, data => this.setState({ requests: data }, this.merge));
	};

	// One list out of two collections: every request (whatever its status) plus every PO
	// that did not come from a request. An approved request already points at its PO row,
	// so showing both would double-count it.
	merge = () => {
		var fromRequest = {};
		var rows = this.state.requests.map(r => {
			if (r.po) fromRequest[('' + r.po).toUpperCase()] = true;
			return {
				ref: r.request_id,
				kind: 'REQUEST',
				po: r.po || '',
				vendor: r.vendor,
				attribute: r.attribute,
				quantity: r.quantity,
				status: r.status,
				requested_at: r.createdAt,
				approved_at: r.status === 'APPROVED' ? r.reviewed_at : null,
				requested_by: r.requested_by,
				reviewed_by: r.reviewed_by,
				remarks: r.remarks,
				reason: r.reason
			};
		});
		this.state.pos.forEach(p => {
			if (fromRequest[('' + p.po).toUpperCase()]) return;
			rows.push({
				ref: p.po,
				kind: 'PO',
				po: p.po,
				vendor: p.vendor,
				attribute: p.attribute,
				quantity: p.quantity,
				// A PO row exists only because it was issued — there is nothing left to approve.
				status: 'APPROVED',
				requested_at: null,
				approved_at: p.date
			});
		});
		// Whatever still needs a decision goes to the top; the rest newest-first.
		rows.sort((a, b) => {
			if ((a.status === 'WAITING') !== (b.status === 'WAITING')) return a.status === 'WAITING' ? -1 : 1;
			return new Date(b.approved_at || b.requested_at || 0) - new Date(a.approved_at || a.requested_at || 0);
		});
		this.setState({ data: rows });
	};

	// total_count / used_count are served by the external activator (SUMMARY_URL), not
	// derived from the PO rows loaded above.
	refreshCounts = () => {
		getAllowedLicenseCount(result => { if (result) this.setState(result); });
		getUsedLicenseCount(result => { if (result) this.setState(result); });
	};

	// ── raise a request ──────────────────────────────────────────────────────
	// A scope of ['*'] means pick from everything master data knows about;
	// anything else is exactly the list the policy grants.
	options = (scope, all) => (scope.indexOf('*') > -1 ? all : scope);

	openRequest = () => {
		var vendors = this.options(this.state.vendorScope, this.state.vendors);
		var attributes = this.options(this.state.attributeScope, Object.keys(this.state.attributes));
		this.setState({
			requestOpen: true,
			form: {
				vendor: vendors.length === 1 ? vendors[0] : '',
				attribute: attributes[0] || '',
				quantity: '',
				remarks: ''
			}
		});
	};

	setForm = key => event => {
		var form = Object.assign({}, this.state.form);
		form[key] = event.target.value;
		this.setState({ form: form });
	};

	submitRequest = () => {
		var form = this.state.form;
		var quantity = Number(form.quantity);
		if (!form.attribute || !Number.isFinite(quantity) || quantity < 1) {
			Message.error('Select a PO type and a quantity of at least 1', 3, { position: 'bottom-right' });
			return;
		}
		// Single-vendor policies do not send one — the server fills it in from the policy.
		var vendors = this.options(this.state.vendorScope, this.state.vendors);
		if (vendors.length !== 1 && !form.vendor) {
			Message.error('Select a vendor', 3, { position: 'bottom-right' });
			return;
		}
		this.setState({ submitting: true });
		createRequest({
			vendor: vendors.length === 1 ? undefined : form.vendor,
			attribute: form.attribute,
			quantity: quantity,
			remarks: form.remarks
		}, ok => {
			this.setState({ submitting: false });
			if (!ok) {
				Message.error('Failed to send request. Try again', 3, { position: 'bottom-right' });
				return;
			}
			this.setState({ requestOpen: false });
			Message.success('License request sent to admin for approval', 3, { position: 'bottom-right' });
			this.reloadRequests();
		});
	};

	// ── row menu ─────────────────────────────────────────────────────────────
	closeMenu = () => this.setState({ menuAnchor: null, menuRow: null });

	openReview = status => () => {
		var row = this.state.menuRow;
		this.setState({
			menuAnchor: null,
			menuRow: null,
			reviewOpen: true,
			reviewRow: row,
			reviewStatus: status,
			reviewPo: status === 'APPROVED' ? row.ref : '',
			reviewReason: ''
		});
	};

	openDetails = () => this.setState({ detailsRow: this.state.menuRow, menuAnchor: null, menuRow: null });

	submitReview = () => {
		var row = this.state.reviewRow;
		var status = this.state.reviewStatus;
		if (status === 'REJECTED' && !this.state.reviewReason.trim()) {
			Message.error('A reason is required so the OEM knows why', 3, { position: 'bottom-right' });
			return;
		}
		if (status === 'APPROVED' && !this.state.reviewPo.trim()) {
			Message.error('Enter the PO number this approval creates', 3, { position: 'bottom-right' });
			return;
		}
		this.setState({ submitting: true });
		review({
			request_id: row.ref,
			status: status,
			po: status === 'APPROVED' ? this.state.reviewPo.trim() : undefined,
			reason: this.state.reviewReason
		}, (ok, code) => {
			this.setState({ submitting: false });
			if (ok) {
				this.setState({ reviewOpen: false, reviewRow: null });
				Message.success('Request ' + STATUS[status].label.toLowerCase(), 3, { position: 'bottom-right' });
				this.reloadRequests();
				this.reloadPos();
				this.refreshCounts();
			} else if (code === 409) {
				Message.error('Already reviewed by someone else. Refreshing', 3, { position: 'bottom-right' });
				this.setState({ reviewOpen: false, reviewRow: null });
				this.reloadRequests();
			} else if (code === 406) {
				Message.error('That PO number already exists. Use a different one', 4, { position: 'bottom-right' });
			} else {
				Message.error('Failed to update request. Try again', 3, { position: 'bottom-right' });
			}
		});
	};

	columns() {
		return [
			{ title: 'PO / Request', field: 'ref' },
			{ title: 'Vendor', field: 'vendor' },
			{ title: 'Type', field: 'attribute', lookup: Object.keys(this.state.attributes).length ? this.state.attributes : undefined },
			{ title: 'Quantity', field: 'quantity', type: 'numeric' },
			{
				title: 'Requested Date', field: 'requested_at', editable: 'never',
				render: row => fmt(row.requested_at)
			},
			{
				title: 'Approval Date', field: 'approved_at', type: 'date',
				render: row => fmt(row.approved_at)
			},
			{
				title: 'Status', field: 'status', editable: 'never',
				render: row => {
					var palette = STATUS[row.status] || STATUS.WAITING;
					return <Chip
						size="small"
						label={palette.label}
						style={{
							color: palette.color,
							backgroundColor: palette.background,
							border: '1px solid ' + palette.border,
							fontWeight: 600
						}}
					/>;
				}
			}
		];
	}

	render() {
		const { classes } = this.props;
		var columns = this.columns();
		var menuRow = this.state.menuRow;
		var reviewing = this.state.reviewRow;
		var details = this.state.detailsRow;
		var reviewable = menuRow && this.state.canReview && menuRow.kind === 'REQUEST' && menuRow.status === 'WAITING';

		var pending = this.state.data.filter(row => row.status === 'WAITING').length;

		var actions = [];
		actions.push({
			icon: () => (
				<Badge badgeContent={pending} max={99} color="error">
					<NotificationsNone color={this.state.pendingOnly ? 'primary' : 'inherit'} />
				</Badge>
			),
			tooltip: pending + ' approval(s) pending' + (this.state.pendingOnly ? ' — click to show all' : ' — click to show only these'),
			isFreeAction: true,
			onClick: () => this.setState({ pendingOnly: !this.state.pendingOnly })
		});
		if (this.state.canRaise) {
			actions.push({
				icon: () => <AddShoppingCart />,
				tooltip: 'Raise PO — request licenses from admin',
				isFreeAction: true,
				onClick: this.openRequest
			});
		}
		actions.push(() => ({
			icon: () => <MoreVert fontSize="small" />,
			tooltip: 'Actions',
			onClick: (event, row) => this.setState({ menuAnchor: event.currentTarget, menuRow: row })
		}));

		var vendorOptions = this.options(this.state.vendorScope, this.state.vendors);
		var attributeOptions = this.options(this.state.attributeScope, Object.keys(this.state.attributes));

		return (
			<div className={classes.root}>
				{this.props.cookies.cookies.policyname === "admin" &&
					<Grid gutter={2} style={{ marginBottom: 20 }}>
						<Grid width={0.33}>
							<h2>TOTAL LICENSES: {this.state.total_count}</h2>
						</Grid>
						<Grid width={0.33}>
							<h2>USED LICENSES: {this.state.used_count}</h2>
						</Grid>
						<Grid width={0.33}>
							<h2>REMAINING LICENSES: {this.state.total_count - this.state.used_count}</h2>
						</Grid>
					</Grid>}
				<MaterialTable
					title={'PO & License Requests'}
					columns={columns}
					data={this.state.pendingOnly ? this.state.data.filter(row => row.status === 'WAITING') : this.state.data}
					isLoading={this.state.isLoading}
					actions={actions}
					options={{
						loadingType: 'overlay',
						addRowPosition: 'first',
						actionsColumnIndex: columns.length,
						exportAllData: true,
						exportButton: true,
						exportDelimiter: ',',
						exportFileName: 'PO_And_Requests',
						pageSize: 10,
						pageSizeOptions: [10, 25, 50]
					}}
					localization={{ body: { emptyDataRow: 'No POs or requests yet' } }}
					editable={{
						// Only real PO rows are editable — a request is changed by approving
						// or rejecting it, never by typing over it.
						isEditable: row => row.kind === 'PO',
						isDeletable: row => row.kind === 'PO',
						onRowAdd: this.state.POST ? newData =>
							new Promise(resolve => {
								create({
									po: newData.ref,
									vendor: newData.vendor,
									attribute: newData.attribute,
									quantity: newData.quantity,
									date: newData.approved_at || new Date()
								}, result => {
									if (result) {
										Message.success('PO created', 3, { position: 'bottom-right' });
										this.reloadPos();
									} else {
										Message.error('Failed to create PO. Try again', 3, { position: 'bottom-right' });
									}
									resolve();
								});
							}) : undefined,
						onRowUpdate: this.state.PUT ? (newData, oldData) =>
							new Promise(resolve => {
								update({ po: oldData.po }, {
									po: newData.ref,
									vendor: newData.vendor,
									attribute: newData.attribute,
									quantity: newData.quantity,
									date: newData.approved_at
								}, result => {
									if (result) {
										Message.success('PO updated', 3, { position: 'bottom-right' });
										this.reloadPos();
									} else {
										Message.error('Failed to update PO. Try again', 3, { position: 'bottom-right' });
									}
									resolve();
								});
							}) : undefined,
						onRowDelete: this.state.DELETE ? oldData =>
							new Promise(resolve => {
								delet(oldData.po, result => {
									if (result) {
										Message.success('PO deleted', 3, { position: 'bottom-right' });
										this.reloadPos();
									} else {
										Message.error('Failed to delete PO. Try again', 3, { position: 'bottom-right' });
									}
									resolve();
								});
							}) : undefined,
					}}
				/>

				{/* per-row menu behind the three dots */}
				<Menu
					anchorEl={this.state.menuAnchor}
					open={Boolean(this.state.menuAnchor)}
					onClose={this.closeMenu}
				>
					<MenuItem onClick={this.openDetails}>
						<ListItemIcon style={{ minWidth: 34 }}><InfoOutlined fontSize="small" /></ListItemIcon>
						Check Details
					</MenuItem>
					{reviewable && <Divider />}
					{reviewable &&
						<MenuItem onClick={this.openReview('APPROVED')}>
							<ListItemIcon style={{ minWidth: 34 }}>
								<CheckCircleOutline fontSize="small" style={{ color: STATUS.APPROVED.color }} />
							</ListItemIcon>
							Approve
						</MenuItem>}
					{reviewable &&
						<MenuItem onClick={this.openReview('REJECTED')}>
							<ListItemIcon style={{ minWidth: 34 }}>
								<HighlightOff fontSize="small" style={{ color: STATUS.REJECTED.color }} />
							</ListItemIcon>
							Reject
						</MenuItem>}
				</Menu>

				{/* details */}
				<Dialog open={Boolean(details)} onClose={() => this.setState({ detailsRow: null })} fullWidth maxWidth="xs">
					<DialogTitle>{details && details.ref}</DialogTitle>
					<DialogContent>
						{details && [
							['Type', details.kind === 'PO' ? 'Purchase Order' : 'License Request'],
							['Vendor', details.vendor],
							['PO Type', details.attribute],
							['Quantity', details.quantity],
							['Status', (STATUS[details.status] || STATUS.WAITING).label],
							['PO Number', details.po || '—'],
							['Requested By', details.requested_by || '—'],
							['Requested Date', fmt(details.requested_at)],
							['Reviewed By', details.reviewed_by || '—'],
							['Approval Date', fmt(details.approved_at)],
							['Remarks', details.remarks || '—'],
							['Reason', details.reason || '—']
						].map(pair =>
							<Typography key={pair[0]} variant="body2" style={{ marginBottom: 4 }}>
								<b>{pair[0]}:</b> {pair[1]}
							</Typography>
						)}
					</DialogContent>
					<DialogActions>
						<Button onClick={() => this.setState({ detailsRow: null })}>Close</Button>
					</DialogActions>
				</Dialog>

				{/* raise a request */}
				<Dialog open={this.state.requestOpen} onClose={() => this.setState({ requestOpen: false })} fullWidth maxWidth="xs">
					<DialogTitle>Raise Purchase Order</DialogTitle>
					<DialogContent>
						{/* One vendor in scope: nothing to choose, so show it locked. */}
						{vendorOptions.length === 1
							? <TextField fullWidth disabled label="Vendor" className={classes.field} value={vendorOptions[0]} />
							: <TextField
								select fullWidth required label="Vendor" className={classes.field}
								value={this.state.form.vendor}
								onChange={this.setForm('vendor')}
							>
								{vendorOptions.map(name => <MenuItem key={name} value={name}>{name}</MenuItem>)}
							</TextField>}
						<TextField
							select fullWidth required label="PO Type" className={classes.field}
							value={this.state.form.attribute}
							onChange={this.setForm('attribute')}
						>
							{attributeOptions.map(name => <MenuItem key={name} value={name}>{name}</MenuItem>)}
						</TextField>
						<TextField
							fullWidth type="number" label="Quantity" className={classes.field}
							inputProps={{ min: 1 }}
							value={this.state.form.quantity}
							onChange={this.setForm('quantity')}
						/>
						<TextField
							fullWidth multiline rows={3} label="Remarks (optional)" className={classes.field}
							value={this.state.form.remarks}
							onChange={this.setForm('remarks')}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={() => this.setState({ requestOpen: false })}>Cancel</Button>
						<Button color="primary" variant="contained"
							disabled={this.state.submitting}
							onClick={this.submitRequest}>Send PO Request</Button>
					</DialogActions>
				</Dialog>

				{/* approve / reject */}
				<Dialog open={this.state.reviewOpen} onClose={() => this.setState({ reviewOpen: false, reviewRow: null })} fullWidth maxWidth="xs">
					<DialogTitle>
						{this.state.reviewStatus === 'APPROVED' ? 'Approve Request' : 'Reject Request'}
					</DialogTitle>
					<DialogContent>
						{reviewing &&
							<div style={{ marginBottom: 8, fontSize: 13, color: '#555' }}>
								<div><b>{reviewing.ref}</b></div>
								<div>{reviewing.vendor} &middot; {reviewing.attribute} &middot; {reviewing.quantity} licenses</div>
								<div>Raised by {reviewing.requested_by} on {fmt(reviewing.requested_at)}</div>
								{reviewing.remarks && <div>Remarks: {reviewing.remarks}</div>}
							</div>}
						{this.state.reviewStatus === 'APPROVED' &&
							<TextField
								fullWidth required label="PO Number" className={classes.field}
								helperText="Creates this PO against the vendor"
								value={this.state.reviewPo}
								onChange={event => this.setState({ reviewPo: event.target.value })}
							/>}
						<TextField
							fullWidth multiline rows={3} className={classes.field}
							label={this.state.reviewStatus === 'REJECTED' ? 'Reason (required)' : 'Note (optional)'}
							required={this.state.reviewStatus === 'REJECTED'}
							value={this.state.reviewReason}
							onChange={event => this.setState({ reviewReason: event.target.value })}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={() => this.setState({ reviewOpen: false, reviewRow: null })}>Cancel</Button>
						<Button
							variant="contained"
							color={this.state.reviewStatus === 'APPROVED' ? 'primary' : 'secondary'}
							disabled={this.state.submitting}
							onClick={this.submitReview}>
							{this.state.reviewStatus === 'APPROVED' ? 'Approve' : 'Reject'}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

export default withStyles(styles)(withCookies(POList));
